export const environment = {
  production:     false,
  apiUrl:         'https://tms-api.dev-urbano.dev/api/v1',
  // apiUrl:         'http://localhost:3000/api/v1',
  geoApiUrl:      'https://api.geo.dev-urbano.dev',
  googleMapsKey:  'AIzaSyD80cj9p4nk0Ff3MBRknKQQ3MOOA2bsprM',
  geocodeUrl:     'https://maps.googleapis.com/maps/api/geocode/json',
  mapboxToken:    'pk.eyJ1IjoiYWRyaWFuY2FzdGFuZWRhMSIsImEiOiJjbXQ4enpyZGIwMWJ1MndvZTc2MTh1NG01In0.jP9CdXBygvOMahhj79BZ-Q',
  urbanitoApiUrl: 'https://34-148-145-136.sslip.io',
};
